import { gql } from '@apollo/client';

export const MEDIA_UPLOADS = gql`
  query MediaUploads($filter: MediaUploadFilter, $sort: MediaUploadSort) {
    mediaUploads(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
        originalFileName
        fileKey
        url
        type
        subtype
        fileType
        mimeType
        size
        width
        height
        metadata
        isArchived
        createdAt
        updatedAt
      }
    }
  }
`;

export const MEDIA_UPLOAD_OPTIONS = gql`
  query MediaUploadOptions {
    mediaUploadOptions {
      modules {
        value
        label
        subtypes {
          value
          label
        }
      }
      fileTypes {
        value
        label
      }
    }
  }
`;

export const GET_MEDIA_UPLOAD_SIGNED_PUT_URL = gql`
  query GetMediaUploadSignedPutUrl($data: GetMediaUploadSignedPutUrlInput!) {
    getMediaUploadSignedPutUrl(data: $data) {
      fileName
      signedUrl
      originalFileName
      mimeType
    }
  }
`;
